/*
  Kiwi Ears · collaboration panels (Rene 2026-08-22).

  Lifted out of an inline script in sections/pk-collab.liquid when the panel
  became a shared snippet. The inline version addressed #pk-collab-row and
  #pk-collab-bg — single ids, which worked while exactly one panel existed on a
  page. The creators page renders four, and ids would have animated the first
  and left the other three still. This walks every .kh-collab instead.

  Motion only. Nothing here fades content in: a stalled tween must never be able
  to leave the copy or the button invisible, so the reveal moves things that are
  already painted. Learned the hard way, 2026-08-15.
*/
(function () {
  if (window.__kiwiCollabReady) return;
  window.__kiwiCollabReady = true;

  var panels = [].slice.call(document.querySelectorAll('.kh-collab'));
  if (!panels.length) return;

  function arm() {
    var g = window.gsap, ST = window.ScrollTrigger;
    if (!g || !ST) return;

    var mm = g.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', function () {
      panels.forEach(function (panel) {
        var copy = panel.querySelector('.kh-collab-copy');
        if (copy && copy.children.length) {
          g.from(copy.children, {
            y: 22, duration: 0.6, stagger: 0.09, ease: 'power3.out',
            scrollTrigger: { trigger: panel, start: 'top 82%', once: true }
          });
        }

        var art = panel.querySelector('.kh-collab-art');
        if (art) {
          g.from(art, {
            y: 34, scale: 0.96, duration: 0.8, ease: 'power3.out',
            scrollTrigger: { trigger: panel, start: 'top 82%', once: true }
          });
        }

        /* Background parallax. The image is pre-scaled so the travel never
           exposes an edge of the panel. */
        var bg = panel.querySelector('.kh-collab-bg');
        if (bg) {
          g.set(bg, { scale: 1.12 });
          g.fromTo(bg, { yPercent: 5 }, {
            yPercent: -5, ease: 'none',
            scrollTrigger: { trigger: panel, start: 'top bottom', end: 'bottom top', scrub: 1.1 }
          });
        }
      });
    });
  }

  if (document.readyState === 'complete') arm();
  else window.addEventListener('load', arm);
})();
